import React, { useState, useEffect } from 'react';
import axios from 'axios';

const MonitoringKBM = ({ token, userRole }) => {
  const [jadwal, setJadwal] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // State untuk Waktu Saat Ini (Jam:Menit)
  const [currentTime, setCurrentTime] = useState('');
  
  // State Mode Filter: Default 'ongoing' untuk Piket, 'all' untuk role lain (atau default 'ongoing')
  const [filterMode, setFilterMode] = useState('ongoing'); 
  
  // Deteksi Hari Ini (Senin, Selasa, dst)
  const hariIndo = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
  const today = hariIndo[new Date().getDay()];
  
  const [selectedHari, setSelectedHari] = useState(today === 'Minggu' ? 'Senin' : today);
  const [tanggal, setTanggal] = useState(new Date().toISOString().split('T')[0]);

  // 1. Timer Waktu Realtime (Update setiap 10 detik)
  useEffect(() => {
    const updateRealtimeClock = () => {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      setCurrentTime(`${hours}:${minutes}`);
    };

    updateRealtimeClock();
    const clockInterval = setInterval(updateRealtimeClock, 10000);
    return () => clearInterval(clockInterval);
  }, []);

  // 2. Fetch Data Monitoring
  useEffect(() => {
    fetchMonitoring();
    // Auto refresh API setiap 30 detik
    const interval = setInterval(fetchMonitoring, 30000);
    return () => clearInterval(interval);
  }, [selectedHari, tanggal]);

  const fetchMonitoring = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`/api/monitoring-kbm`, {
        params: { hari: selectedHari, tanggal: tanggal },
        headers: { Authorization: `Bearer ${token}` }
      });
      setJadwal(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  // Helper untuk mengecek status waktu KBM (Sedang Berlangsung, Selesai, atau Belum)
  const getStatusWaktu = (jamMulaiStr, jamSelesaiStr) => {
    const jamMulai = jamMulaiStr.slice(0, 5);
    const jamSelesai = jamSelesaiStr.slice(0, 5);

    if (currentTime >= jamMulai && currentTime <= jamSelesai) {
      return 'ongoing'; // Sedang Berlangsung
    } else if (currentTime > jamSelesai) {
      return 'passed';  // Sudah Selesai
    } else {
      return 'upcoming'; // Belum Masuk
    }
  };

  // Filter List Jadwal berdasarkan Mode Filter
  const displayedJadwal = jadwal.filter((j) => {
    if (filterMode === 'all') return true;
    
    // Jika mode 'ongoing', hanya tampilkan yang jamnya sedang berjalan detik ini
    const statusWaktu = getStatusWaktu(j.jam_mulai, j.jam_selesai);
    return statusWaktu === 'ongoing';
  });

  // Hitung Statistik Ringkas (Berdasarkan jadwal yang ditampilkan)
  const totalKelas = displayedJadwal.length;
  const kbmAktif = displayedJadwal.filter(j => j.status_kbm === 'berjalan').length;
  const belumHadir = totalKelas - kbmAktif;

  return (
    <div style={{ paddingBottom: '50px' }}>
      
      {/* HEADER & FILTER */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', flexWrap:'wrap', gap:'15px' }}>
        <div>
          <h2 style={{ color: '#1e293b', margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            📡 Monitoring KBM Real-time
            {currentTime && (
              <span style={{ fontSize: '14px', background: '#3b82f6', color: 'white', padding: '2px 10px', borderRadius: '20px', fontWeight: 'bold' }}>
                🕒 {currentTime} WIB
              </span>
            )}
          </h2>
          <p style={{ margin: '5px 0 0', color: '#64748b' }}>Pantau aktivitas belajar mengajar di seluruh kelas.</p>
        </div>

        {/* CONTROLLER FITUR & HARIAN */}
        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
          
          {/* TOGGLE FILTER JAM */}
          <div style={{ background: '#e2e8f0', padding: '4px', borderRadius: '8px', display: 'flex', gap: '4px' }}>
            <button
              onClick={() => setFilterMode('ongoing')}
              style={{
                padding: '6px 12px',
                borderRadius: '6px',
                border: 'none',
                background: filterMode === 'ongoing' ? '#2563eb' : 'transparent',
                color: filterMode === 'ongoing' ? 'white' : '#475569',
                fontWeight: 'bold',
                fontSize: '13px',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
            >
              🔥 Jam Sekarang
            </button>
            <button
              onClick={() => setFilterMode('all')}
              style={{
                padding: '6px 12px',
                borderRadius: '6px',
                border: 'none',
                background: filterMode === 'all' ? '#2563eb' : 'transparent',
                color: filterMode === 'all' ? 'white' : '#475569',
                fontWeight: 'bold',
                fontSize: '13px',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
            >
              📋 Semua Jam
            </button>
          </div>

          <div style={{ display: 'flex', gap: '8px', background: 'white', padding: '6px 10px', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}>
            <select 
              value={selectedHari} 
              onChange={(e) => setSelectedHari(e.target.value)} 
              style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 'bold' }}
            >
              {['Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'].map(h => <option key={h} value={h}>{h}</option>)}
            </select>
            <input 
              type="date" 
              value={tanggal} 
              onChange={(e) => setTanggal(e.target.value)} 
              style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
            />
            <button onClick={fetchMonitoring} style={{ padding: '6px 12px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>🔄 Refresh</button>
          </div>

        </div>
      </div>

      {/* DASHBOARD RINGKASAN */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' }}>
        <div style={{ background: 'linear-gradient(135deg, #3b82f6, #2563eb)', color: 'white', padding: '20px', borderRadius: '12px' }}>
          <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{totalKelas}</div>
          <div style={{ fontSize: '14px', opacity: 0.9 }}>
            {filterMode === 'ongoing' ? 'Jadwal Aktif Jam Ini' : 'Total Jadwal Hari Ini'}
          </div>
        </div>
        <div style={{ background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', padding: '20px', borderRadius: '12px' }}>
          <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{kbmAktif}</div>
          <div style={{ fontSize: '14px', opacity: 0.9 }}>✅ Guru Sudah Masuk</div>
        </div>
        <div style={{ background: 'linear-gradient(135deg, #f43f5e, #e11d48)', color: 'white', padding: '20px', borderRadius: '12px' }}>
          <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{belumHadir}</div>
          <div style={{ fontSize: '14px', opacity: 0.9 }}>⚠️ Belum Absen / Kosong</div>
        </div>
      </div>

      {/* GRID JADWAL KELAS */}
      {loading ? <p style={{textAlign:'center', padding: '40px', color: '#64748b'}}>Memuat data monitoring...</p> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
          {displayedJadwal.length === 0 ? (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '50px 20px', background: 'white', borderRadius: '12px', color: '#64748b', border: '1px dashed #cbd5e1' }}>
              ☕ <b style={{ fontSize: '16px', color: '#334155' }}>
                {filterMode === 'ongoing' ? `Tidak ada KBM yang sedang berlangsung pada jam ${currentTime}.` : 'Tidak ada jadwal pada hari ini.'}
              </b>
              <p style={{ margin: '8px 0 0', fontSize: '13px' }}>
                {filterMode === 'ongoing' && 'Gunakan tombol "📋 Semua Jam" di atas jika ingin melihat seluruh jadwal seharian.'}
              </p>
            </div>
          ) : (
            displayedJadwal.map((j) => {
              const statusWaktu = getStatusWaktu(j.jam_mulai, j.jam_selesai);
              
              return (
                <div key={j.jadwal_id} style={{ 
                  background: 'white', borderRadius: '12px', padding: '20px', 
                  borderLeft: j.status_kbm === 'berjalan' ? '6px solid #10b981' : '6px solid #f43f5e',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.05)', position: 'relative',
                  opacity: (filterMode === 'all' && statusWaktu === 'passed') ? 0.65 : 1 // Tampilan redup jika jamnya sudah lewat pada mode 'Semua Jam'
                }}>
                  
                  {/* BADGE JAM & INDICATOR */}
                  <div style={{ position: 'absolute', top: '15px', right: '15px', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                    <div style={{ background: '#f1f5f9', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', color: '#64748b' }}>
                      {j.jam_mulai.slice(0,5)} - {j.jam_selesai.slice(0,5)}
                    </div>
                    {filterMode === 'all' && (
                      <span style={{ 
                        fontSize: '10px', fontWeight: 'bold', padding: '2px 6px', borderRadius: '4px',
                        background: statusWaktu === 'ongoing' ? '#dbeafe' : statusWaktu === 'passed' ? '#f1f5f9' : '#fef3c7',
                        color: statusWaktu === 'ongoing' ? '#1d4ed8' : statusWaktu === 'passed' ? '#64748b' : '#b45309'
                      }}>
                        {statusWaktu === 'ongoing' ? '🔴 Berlangsung' : statusWaktu === 'passed' ? 'Selesai' : 'Belum Masuk'}
                      </span>
                    )}
                  </div>
                  
                  <h3 style={{ margin: '0 0 5px', color: '#1e293b' }}>{j.nama_kelas}</h3>
                  <div style={{ fontWeight: 'bold', color: '#4361ee', marginBottom: '15px', fontSize: '16px' }}>{j.mapel}</div>
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
                    <div style={{ width: '40px', height: '40px', background: '#e0e7ff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>👨‍🏫</div>
                    <div>
                      <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#334155' }}>{j.nama_guru}</div>
                      <div style={{ fontSize: '11px', color: '#64748b' }}>NIP: {j.nip}</div>
                    </div>
                  </div>

                  <div style={{ borderTop: '1px dashed #e2e8f0', paddingTop: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontSize: '13px', color: '#64748b' }}>Status KBM:</div>
                    {j.status_kbm === 'berjalan' ? (
                      <span style={{ background: '#dcfce7', color: '#166534', padding: '5px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>
                        ✅ Terabsen ({j.jumlah_siswa_absen} Siswa)
                      </span>
                    ) : (
                      <span style={{ background: '#fee2e2', color: '#991b1b', padding: '5px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>
                        ⚠️ Belum Absen
                      </span>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
};

export default MonitoringKBM;